import React, { useState, useEffect } from "react";
import "datatables.net-dt/js/dataTables.dataTables";
import { Tabs, Tab } from "@appkit4/react-components/tabs";
import "../../../../../src/styles/userManagement.css";
import UpdatedSelfAssessment from "./updateAssessment";
import AllSelfAssessments from "./allSelfassessments";
import APIService from "../../../../services/apiAxiosService";
import useHttp from "../../../../hooks/useHttp";

export default function InitiateSelf(props) {
  const [currentTab, setCurrentTab] = useState("1");
  const [createTab, setCreateTab] = useState(true);
  const [assessmentData, setAssessmentData] = useState([]);
  const [updateData, setUpdateData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [tableData, setTableData] = useState([])
  const { sendRequest: fetchUpdateSelfAssessmentList } = useHttp();
  const { sendRequest: getSelfAssessments } = useHttp();

  useEffect(() => {
    getSelfAssessmentsforAssessor();
    getUpdatedSelfRequests();
  }, []);

  const getSelfAssessmentsforAssessor = async () => {
    setLoader(true);
    getSelfAssessments(APIService.getSelfAssessments(), (res) => {
      if (res.CODE) {
        setAssessmentData(res.MSG);
      }
    })
    setLoader(false);
  };

  const getUpdatedSelfRequests = async () => {
    setLoader(true);
    fetchUpdateSelfAssessmentList(APIService.fetchUpdateSelfAssessmentList(),
    (res) => {
      if (res.CODE) {
        setUpdateData(res.MSG);
      }
    })
    setLoader(false);
  };

  const handleTabs = (e, v) => {
    setCurrentTab(v);
    setCreateTab(true);
  };

  return (
    <div className="App">
      <div className="user-management-container">
        <Tabs
          defaultValue={currentTab}
          value={currentTab}
          onChange={handleTabs}
          className="a-tab-item-padding-10"
        >
          <Tab
            value="1"
            label={"All Self Assessment Requests"}
          >
            {loader ? (
              <div className="row" id="preloader">
                <div className="col-12 col-lg-12 loader-margin text-center">
                  <div className="a-loading a-primary a-m-10">
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>
              </div>
            ) : (
              <div>
              < AllSelfAssessments AssessmentData={assessmentData} getSelfAssessmentsforAssessor={getSelfAssessmentsforAssessor} />   
              </div>
            )}
          </Tab>
          <Tab value="2" label="Review Self Assessments">
            <UpdatedSelfAssessment  Plan={updateData} getApproveSelfRequests={getUpdatedSelfRequests}/>
          </Tab>
        </Tabs>
      </div>
    </div>
  );
}
